"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let reducedMotion = window.matchMedia("(prefers-reduced-motion)");
if (!reducedMotion.matches) {
    if (document.querySelector('.footer__end-back-to-top')) {
        document.querySelector('.footer__end-back-to-top').addEventListener("click", function (e) {
            e.preventDefault();
            let url = this.getAttribute("href");
            let parsedUrl = new URL(url);
            let fragment = parsedUrl.hash;
            if (fragment !== undefined && fragment !== "") {
                history.pushState(null, null, url);
                let fragmentTarget = document.querySelector(`${fragment}`);
                if (fragmentTarget) {
                    fragmentTarget.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "start"
                    });
                }
            }
        });
    }
}
exports.default = {};
